export const CARDS_API_ENDPOINTS = {
  CARDS: "/internal/cards",
} as const;

/** Cantidad de movimientos por página al cargar "más". */
export const MOVEMENTS_PAGE_SIZE = 10;

/** The card provider renders the alias on the card and rejects anything longer. */
export const CARD_ALIAS_MAX_LENGTH = 26;
